import { useState } from 'react'
import styles from '@/components/directory/v2/list-view/EVsListItemModelComponent.module.css'
import PriceIndicator from '@/components/ui/cards/attributes/PriceIndicator'
import { FaCaretDown } from 'react-icons/fa'

const EVsListItemModelComponent = ({ model_object, showVariants }) => {
  const [imageLoaded, setImageLoaded] = useState(false)

  const { make, model, variant_count, image, min_price_category, max_price_category } = model_object

  // Determine the source of the image
  const hasImage = !!image
  const imageUrl = image || '/illustrations/v2/EV-v1.png'
  const imageClassName = hasImage ? styles.cardImage : styles.fallBackImage
  const containerClassName = hasImage ? styles.imageContainer : styles.fallbackImageContainer

  // Image loading event handlers
  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  return (
    <div className={styles.container}>
      <div className={styles.picture}>
        <div className={containerClassName}>
          {!imageLoaded && <div className={styles.loader}></div>}
          <img
            className={imageClassName}
            src={imageUrl}
            alt={`${make} ${model}`}
            onLoad={handleImageLoad}
            style={{ display: imageLoaded ? 'block' : 'none' }}
          />
        </div>
      </div>
      <div className={styles.details}>
        <div className={styles.name}>{`${make} ${model}`}</div>
        <div className={styles.variants}>{variant_count} Variants</div>
        <div className={styles.price}>
          <PriceIndicator min_price_category={min_price_category} max_price_category={max_price_category} />
        </div>
        <FaCaretDown className={`${styles.caretIcon} ${showVariants ? styles.caretIconRotated : ''}`} />
      </div>
    </div>
  )
}

export default EVsListItemModelComponent
